import * as Yup from 'yup';

export const SetUpADriverAccountFromExcelSchema = Yup.object().shape({
    excelFile: Yup.mixed<File | File[]>()
        // .required('An excelFile is required')
        .nullable()
        .test('fileType', 'Unsupported file format', (value: File | File[] | null | undefined) => {
            if (!value) return true;
            const files = Array.isArray(value) ? value : [value];
            return files.every(file => [
                'text/csv',
                'application/csv',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ].includes(file.type));
        })
        .test('fileSize', 'File size too large (Max: 15MB)', (value: File | File[] | null | undefined) => {
            if (!value) return true;
            const files = Array.isArray(value) ? value : [value];
            return files.every(file => file.size <= 15 * 1024 * 1024); // 15MB limit per file
        }),
});

export type SetUpADriverAccountFromExcelDataType = Yup.InferType<typeof SetUpADriverAccountFromExcelSchema>;

type InitialValues = {
    excelFile: File | null;
};

export const SetUpADriverAccountFromExcelInitialValues: InitialValues = {
    excelFile: null,

};


export interface SetUpADriverAccountFromExcelInterface {
    excelFile: string;
};

